module.exports = __webpack_public_path__ + "static/fonts/Nunito-BoldItalic.15c900f.woff2";